// A car with no base daily price can't be booked online.
export const hasNoPrice = (car?: { price?: number | string | null } | null) => !!car && !(Number(car.price) > 0);

// The operator turned on "Price on request" for this car, with or without a daily price.
export const isPriceOnRequest = (car?: { price_on_request?: boolean | null } | null) => car?.price_on_request === true;

// Either way the car can't be opened or booked online: renters get a quote
// (price on request) or are told a price is coming (unpriced, toggle off).
export const isNotBookable = (
  car?: { price?: number | string | null; price_on_request?: boolean | null } | null,
) => isPriceOnRequest(car) || hasNoPrice(car);

// 1NOW-11175: the percentage on a card's badge. A markup past 90 (the "-892%" a stale was-price
// produced) or below 1 is not a discount a renter can believe, so the badge, and the crossed-out
// price it explains, are left off.
export const MAX_BADGE_PERCENT = 90;
export const badgePercent = (markup: number | null | undefined): number | null =>
  typeof markup === "number" && Number.isFinite(markup) && markup >= 1 && markup <= MAX_BADGE_PERCENT ? markup : null;
